import { InjectionKey, Ref } from 'vue';

interface AppProvide {
    currentTime: Ref<Date>;
    // ORDER_TRAVELCARD_URL: Ref<string>;
    gmapsApiKey: Ref<string>;
}

export const AppProvideKey: InjectionKey<AppProvide> = Symbol.for('webshop:app');
